<form name="renovarContratoAutomaticamenteModal">
  <div class="modal-header">
    <h3 class="modal-title">Renovação de contrato</h3>
  </div>
  <div class="modal-body">
    <p>Prezado cliente, seu contrato irá vencer em {{daysRemainingContract}} dias.</p>
    <p>
      Pedimos, por gentileza, para que entre em contato para encaminhar a renovação, antes do vencimento, após esta data o sistema ficará <b>bloqueado</b> 
      temporariamente até a regularização do contrato
    </p>
    <a aria-label="bla" href="https://wa.me/{{$ctrl.CONTACT_RENOVATION}}" target="_blank" class="pull-right">
      <img src="https://cdn-icons-png.flaticon.com/512/174/174879.png" style="max-width: 20px; margin-right: 3px;">
      Entrar em contato
    </a>
  </div>
  <div class="modal-footer">
    <button class="btn btn-white" type="button" ng-disabled="$ctrl.loading" ng-click="$ctrl.sendRenovation(false)">Não tenho interesse em renovar
      <span ng-show="$ctrl.loadingReject">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    </button>
    <button class="btn btn-primary" type="submit" ng-click="$ctrl.sendRenovation(true)">
      Encaminhar renovação
      <span ng-show="$ctrl.loadingApprove">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    </button>
  </div>
</form>
